import { useGlobalSharedState } from "Hooks/useSharedState";
import { listSiteinfos } from "features/analytics/services/analyticsLabelService";

const fetchSiteinfos = async () => {
  const res = await listSiteinfos();
  return res;
};

export const useSiteinfo = () => {
  const { state, setState, loading, fetched } = useGlobalSharedState("siteinfos", [], fetchSiteinfos);
  return { siteinfos: state, setSiteinfos: setState, loading, fetched };
};